<div
  class="table"
  [class.expanded]="isExpanded"
  *ngIf="loading || (!loading && data?.length); else emptyPlug"
  prlwResponsive
>
  <div *ngIf="overflows?.top" class="top-fade" prlwResponsive></div>
  <div *ngIf="overflows?.bottom" class="bottom-fade" prlwResponsive></div>
  <div *ngIf="overflows?.left" class="left-fade" prlwResponsive></div>
  <div *ngIf="overflows?.right" class="right-fade" prlwResponsive></div>

  <div
    *ngIf="(xsmall$ | async) === false"
    class="header-row"
    [class.header-row--right-plug]="overflows?.right"
    [class.header-row--left-plug]="overflows?.left"
  >
    <div
      *ngIf="overflows?.right"
      class="header-row-fade header-row-fade--right"
    ></div>
    <div
      *ngIf="overflows?.left"
      class="header-row-fade header-row-fade--left"
    ></div>
  </div>

  <div
    #tableContentWrapper
    class="table-content-wrapper"
    (scroll)="setHorizontalScroll($event)"
    prlwSyncScroll
  >
    <div
      *ngIf="rowHover.isVisible"
      class="row-hover"
      [ngStyle]="{ top: rowHover.offset }"
    ></div>

    <prlw-last-deals-table-header-row
      *ngIf="(xsmall$ | async) === false"
      [showContent]="!loading && !!data"
    ></prlw-last-deals-table-header-row>

    <div class="table-content" *ngIf="!loading && data; else contentLoader">
      <div
        #scroll
        class="scroll"
        (scroll)="processVerticalScroll($event)"
        prlwResponsive
      >
        <div
          *ngFor="let deal of data; let i = index"
          class="table-row"
          [class.summary-item]="isSummaryItem(deal)"
          [ngStyle]="{ 'grid-template-columns': gridSize }"
          [class.table-row--hovered]="rowHover.index === i"
          [class.table-row--previous-hovered]="rowHover.index === i + 1"
          (mouseenter)="setRowHover($event, i)"
          (mouseleave)="setRowHover(null)"
        >
          <prlw-last-deals-table-content
            *ngFor="let column of columns"
            [columnId]="column.id"
            [deal]="deal"
          ></prlw-last-deals-table-content>
        </div>
        <prlw-last-deals-fetch-more-button-ui
          *ngIf="(xsmall$ | async) === false && !noDealsAnymore"
          [buttonLoading]="buttonLoading"
          (eventFetchMore)="eventFetchMore.emit()"
          [fetchMoreLabel]="fetchMoreLabel"
        ></prlw-last-deals-fetch-more-button-ui>
      </div>
    </div>
  </div>
  <prlw-last-deals-fetch-more-button-ui
    *ngIf="(xsmall$ | async) && !noDealsAnymore"
    [buttonLoading]="buttonLoading"
    (eventFetchMore)="eventFetchMore.emit()"
    [fetchMoreLabel]="fetchMoreLabel"
  ></prlw-last-deals-fetch-more-button-ui>
</div>

<ng-template #contentLoader>
  <div class="loader-plug-wrapper" *ngFor="let plug of loaderPlugsLength">
    <div class="loader-plug loader-plug--basis"></div>
    <div class="loader-plug"></div>
  </div>
</ng-template>

<ng-template #emptyPlug>
  <div class="plug-wrapper" [class.expanded]="isExpanded">
    <span>Сегодня не было сделок по выбранному базису</span>
  </div>
</ng-template>
